module.exports = __webpack_public_path__ + "assets/media/externalLinks-yio.c763a5ee.svg";